import { useMutation } from '@tanstack/react-query'
import { useRouteContext } from '@tanstack/react-router'
import { cloneElement, useState } from 'react'
import { createSite } from '../service'
import { Dialog } from '@radix-ui/themes'
import { CreateSiteSchema } from '../schemas'
import { useTranslation } from 'react-i18next'
import { CreateSiteForm } from './SiteForm'

interface CreateSiteDialogProps {
  children: React.ReactElement
}

const CreateSiteDialog = ({ children }: CreateSiteDialogProps) => {
  const { t } = useTranslation('sites')
  const [open, setOpen] = useState(false)
  const { queryClient, org } = useRouteContext({
    from: '/sites/'
  })

  const { mutate, isPending } = useMutation({
    mutationFn: createSite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sites'] })
      setOpen(false)
    },
    onError: (error) => {
      console.error('Error creating site', error)
    }
  })

  const onSubmit = async (data: CreateSiteSchema) => {
    mutate({ ...data, orgID: org.id })
  }

  // @ts-ignore
  const trigger = cloneElement(children, { onClick: () => setOpen(true) })

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger>{trigger}</Dialog.Trigger>
      <Dialog.Content>
        <Dialog.Title>{t('sites.form.title')}</Dialog.Title>
        <CreateSiteForm onSubmit={onSubmit} isPending={isPending} />
      </Dialog.Content>
    </Dialog.Root>
  )
}

export { CreateSiteDialog }
